<template>
    <div class="gray-back" style="padding:.2rem 0 1rem 0">
        <van-form
                @submit="onSubmit"
                @failed="onFailed"
        >
            <!--
            <van-divider>确认发票信息</van-divider>

            <van-cell-group>

                <van-field
                        v-model="row.fapiao_taitou"
                        :rules="[{ required: true, message: '发票抬头不能为空' }]"
                        label="发票抬头"
                        input-align="right"
                        error-message-align="right"
                        clearable
                        placeholder="请输入发票抬头"
                />
                <van-field
                        v-model="row.fapiao_shuihao"
                        :rules="[{ required: true, message: '税号不能为空' }]"
                        label="税号"
                        :border="false"
                        input-align="right"
                        error-message-align="right"
                        clearable
                        placeholder="请输入税号"
                />
                <div class="operate-desc-left">如果您所在的单位没有纳税人识别号请填写“无”</div>

                <van-field
                        v-model="row.fapiao_beizhu"
                        label="发票备注"
                        input-align="right"
                        clearable
                        placeholder="请输入发票备注"
                />
                <van-field
                        v-model="row.fapiao_email"
                        :rules="[{ validator: validator.email, message: '请输入正确的邮箱' }]"
                        error-message-align="right"
                        label="接收邮箱"
                        input-align="right"
                        clearable
                        placeholder="请输入接收邮箱"
                />
                <van-field
                        v-model="row.fapiao_phone"
                        :rules="[{ validator: validator.phone,message:'请输入正确的手机号'}]"
                        error-message-align="right"
                        label="接收手机"
                        input-align="right"
                        clearable
                        placeholder="请输入接收手机"
                />

                <div class="fapiao-tip-wrap">
                    <div>
                        发票1 金额：{{parseInt(row.order.memberprice)+parseInt(row.order.otherprice)}}元  名目：赛事综合服务费
                    </div>
                    <div v-show="row.order.shisuprice>0">
                        发票2 金额：{{row.order.shisuprice}}元  名目：食宿费
                    </div>
                </div>
                <div style="height: 0.2rem"></div>
                <div style="text-align: center" v-show="false">
                    <van-button
                            style="width: 3rem; margin: 10px;"
                            size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="保存中..." native-type="submit" @click="save">确认发票信息</van-button>
                </div>

            </van-cell-group>
-->

            <van-divider>费用信息</van-divider>

            <van-cell-group>

                <van-cell
                        input-align="right"
                        title="赛事综合服务费"
                        :value="row.order.memberprice"
                />
                <van-cell
                        input-align="right"
                        title="食宿费"
                        :value="row.order.shisuprice"
                />
                <van-cell
                        input-align="right"
                        title="其他服务费"
                        :value="row.order.otherprice"
                />
                <van-cell
                        input-align="right"
                        title="费用总计"
                        :value="row.order.total"
                />

            </van-cell-group>


            <div class="savebtn">
                <van-button
                        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                        style="width: 3rem"
                        size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">确定提交</van-button>
            </div>
        </van-form>

        <!-- <van-action-sheet v-model="payShow" v-if="row.saiqu>0" :actions="(row.saiqu==515||row.saiqu==655||row.saiqu==654||row.saiqu==656) ? payActions2:payActions" @select="onPaySelect" /> -->
        <van-action-sheet v-model="payShow" v-if="row.saiqu>0" :actions="(row.third_pay_info) ? payActions2:payActions" @select="onPaySelect" />
        <van-dialog v-model="payOffShow" title="请线下汇款" show-cancel-button 
            confirm-button-text="我已支付，上传凭证" @confirm="beizhu"
        >
        <!-- <p style="text-align: center;">  -->
            <!-- <img style="width: 70%;" :src="row.sai_pay_img"  /> -->
        <!-- </p> -->
        <div v-if="row.third_pay_img||row.third_pay_info"> 
            <p style="text-align: center;" v-show="row.third_pay_img"> 
             <img style="width: 70%;" :src="row.third_pay_img"  /> 
             <br/>
            <van-button size="normal" round @click="downloadpicUrl(row.third_pay_img)" >下载图片</van-button>   
         </p> 
            <p  style="text-align: left; line-height:30px;padding:10px" v-html="row.third_pay_info">
            </p>
            <p style="text-align:center">
            <van-button size="normal" round v-clipboard:copy="br2nl(row.third_pay_info)"
                            v-clipboard:success="onCopy" >复制文本</van-button>
            </p>

        </div>
        <div v-else-if="(row.saiqu==515||row.saiqu==655||row.saiqu==654)"> 
            <p  style="text-align: left; line-height:30px;padding:10px" v-html="shisu_pay_info">
        </p>
        <p style="text-align:center">
         <van-button size="normal" round v-clipboard:copy="br2nl(shisu_pay_info)"
                        v-clipboard:success="onCopy" >复制文本</van-button>
        </p>


            <p  style="text-align: left; line-height:30px;padding:10px" v-html="fuwu_pay_info">
        </p>

        <p style="text-align:center">
         <van-button size="normal" round v-clipboard:copy="br2nl(fuwu_pay_info)"
                        v-clipboard:success="onCopy" >复制文本</van-button>
        </p>
        </div>

        <div v-else-if="(row.saiqu==656)"> 
            <p  style="text-align: left; line-height:30px;padding:10px" v-html="zibo_pay_info">
        </p>
        <p style="text-align:center">
         <van-button size="normal" round v-clipboard:copy="br2nl(zibo_pay_info)"
                        v-clipboard:success="onCopy" >复制文本</van-button>
        </p>

 
        </div> 
        
        <div v-else>
            <p  style="text-align: left; line-height:30px;padding:10px" v-html="row.sai_pay_info">
        </p>
        <p  style="text-align: center;"> 
             <!-- <van-button size="normal" round @click="downloadpic" >下载图片</van-button>   -->
            <van-button size="normal" round v-clipboard:copy="br2nl(row.sai_pay_info)"
                        v-clipboard:success="onCopy" >复制文本</van-button>
        </p>
        </div>
        
        </van-dialog>
        <PayDialog :show="payDialogShow" scene="sai_baoming" :ids="orderIds" @onPayError="onPayError" @onPaySuccess="onPaySuccess"
                   @onPayClose="onPayClose"/>


    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }

    .fapiao-tip-wrap{
        background: #F3F3F3;
        margin: 0.2rem;
        border-radius: 8px;
        line-height: 36px;
        padding: 0.2rem;
        font-size: 14px;
        color: #666;
    }
    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }


    .van-tag {
        width: 55px;
        margin-left: 10px;
        text-align: center;
    }
    .between {
        justify-content: space-between;
    }


</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';
    import FileUploader from '@/components/picker/FileUploader.vue';

    import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,ActionSheet,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';
    import CaipanPicker from '@/components/picker/CaipanPicker.vue';
    import FamliyPicker from '@/components/picker/FamliyPicker.vue';

    import PayDialog from '@/components/PayDialog.vue';

    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(ActionSheet).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'SaiApplyFormStep2',
        components: {
            [Field.name]: Field,
            PicUploader,
            PayDialog,
            FileUploader,
        },
        data: function () {
            return {
                validator,
                shisu_pay_info: '食宿付款万式:银行转账，请在汇款单上注明参加赛事及学校名称。<br/>\n账户名称:淮扬菜集团股份有限公司<br/>\n银行账号:8110501013302205747<br/>\n开户银行:中信银行淮安分行<br/>\n行 号:3023080626',
                fuwu_pay_info: '参赛费用付款万式:银行转账，请在汇款单上注明参加赛事及学校名称。<br/>\n账户名称:淮安奥体体育场馆运营管理有限公司<br/>\n银行账号:397009800018010148184<br/>\n开户银行:交通银行准安分行营业部',
                zibo_pay_info: '银行转账：请在汇款单上注明学校名称及联系方式<br/>\n账户名称：山东鸿成教育体育科技集团有限公司<br/>\n银行账号：801114401421002623<br/>\n开户银行:齐商银行淄博支行<br/>\n行号：313453001092',
                payDialogShow:false,
                payOffShow:false,
                payShow:false,
                saveLoading:false,
                showArea:false,
                areaList:{},
                areaValue:'',
                submitType:'',
                subjectName:'',
                orderIds:[],
                subjectArray:[],
                subjectOptions:[],
                row:{
                    order:{

                    },
                    sai_pay_info:''
                },
                payActions:[
                    { name: '线下汇款转账，他人代付' } ,{ name: '在线支付（微信，支付宝）' }
                ],
                payActions2:[
                     { name: '线下汇款转账，他人代付' } 
                ]
            }
        },
        filters: {
        },
        mounted() {
            document.title = '确认费用';
            let that = this;
            that.row.id = this.$route.query.id;
            if(that.row.id){
                this.fetch();
            }
        },
        watch: {
            formData() {
            }
        },
        destroyed() {
        },
        methods: {
            br2nl(val){
                return val.replace(/<.*?>/g,"")
            },
            onQuestion(){
                console.log('onQuestion')
            },
            onSubmit(values){
                console.log('onSubmit-values',values);
                console.log('submitType',this.submitType);

                let that = this;
                console.log(that.formData)
                that.formValidate = true;
                for (let field in that.formData) {

                }
                that.saveLoading = true;

                that.$api.post('/api/isai/ordersave', that.row, (res) => {
                    that.saveLoading = false;

                    that.orderIds = res.data.ids;



                    that.payShow = true;

                }, (res) => {
                    Toast.fail(res.msg);
                    that.saveLoading = false;
                })
            },
            save(values){
                this.submitType = 'save';
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },
            fetch(){
                let that = this;
                that.$api.post('/api/isai/step5detail', {
                    id:that.row.id
                }, (res) => {
                    that.row = res.data;
                    if(that.row.memberstatus==6){

                        rbLink({
                            name:'ISaiApplyFormSuccess',
                            query:{
                                id:that.row.id
                            }
                        },'replace')

                    }
                }, (res) => {
                    Toast.fail(res.msg);
                })
            },

            onPayError() {
                let that = this;
                console.log('onPayError 支付失败');
                that.payDialogShow = false;

                that.$toast('支付失败');

                rbLink({
                    name:'ISaiApplyList'
                },'replace')

            },
            onPaySuccess() {
                let that = this;
                console.log('onPaySuccess 支付成功');
                that.payDialogShow = false;


                appEvent({
                    name: 'saiApplyDetailReload',
                    query: {
                    }
                });

                setTimeout(function () {
                //     rbLink({
                //         name:'ISaiApplyFormSuccess',
                //         query:{
                //             id:that.row.id
                //         }
                //     },'replace')
                //
                    that.fetch();

                },2000);

            },
            onPayClose() {
                let that = this;
                console.log('onPayClose 支付关闭');
                that.payDialogShow = false;


                appEvent({
                    name: 'saiApplyDetailReload',
                    query: {
                    }
                });

                setTimeout(function () {
                    rbLink({
                        name:'ISaiApplyList'
                    },'replace')


                    // that.fetch();
                },500);
            },
            onPaySelect(item,index) {
                // 默认情况下点击选项时不会自动收起
                // 可以通过 close-on-click-action 属性开启自动收起
                this.payShow = false;
                if(index == 1){
                    this.payDialogShow = true;
                }else{
                    this.payOffShow = true; 
                } 
            },

            onCopy() {
                Toast.success('复制成功') 
            },
            downloadpic(){ 
                let that = this;
                appEvent({
                    name: 'downloadPic',
                    query: {
                        'filename' : 'sai-pay.png',
                        'url' : that.row.sai_pay_img
                    }
                }); 
            },
            downloadpicUrl(url){ 
                let that = this;
                if(window.isApp()){
                    appEvent({
                        name: 'downloadPic',
                        query: {
                            'filename' : 'sai-pay.png',
                            'url' : url
                        }
                    }); 
                }else{
                    that.$toast('请长按图片保存，或者截图保存');
                }
            },

            beizhu(){
                let that = this;
                rbLink({
                    'name' : 'SaiApplyBeizhu',
                    'query':{
                        id: that.row.id
                    }
                } )
            },

        }
    }
</script>



// WEBPACK FOOTER //
// SaiApplyFormStep5.vue?0899c637